import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useT } from "@/i18n";

// Full-width attention ribbon for the public landing page advertising the
// admin-configured free trial. Sits directly under the header so visitors
// see it before they even start scrolling. Auto-hides when the admin flips
// the toggle OFF — no manual landing edits needed.
export default function TrialRibbon() {
  const { t } = useT();
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/billing/trial-config").then((r) => {
      if (alive) setCfg(r.data || null);
    }).catch(() => { /* ribbon stays hidden */ });
    return () => { alive = false; };
  }, []);

  if (!cfg?.enabled || !cfg?.days) return null;

  return (
    <Link
      to="/auth?mode=register"
      data-testid="trial-ribbon"
      className="block w-full text-white relative overflow-hidden hover:opacity-95 transition-opacity"
      style={{ background: "linear-gradient(90deg,#f59e0b 0%,#f97316 35%,#ec4899 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-center gap-3 text-center flex-wrap">
        <Sparkles className="w-4 h-4 shrink-0 animate-pulse" />
        <span className="font-bold text-sm sm:text-base">
          {t("trial_ribbon_text", { days: cfg.days })}
        </span>
        <span className="hidden sm:inline-flex items-center gap-1 bg-white/20 backdrop-blur px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider">
          {t("trial_ribbon_pill")}
        </span>
        <span className="inline-flex items-center gap-1 bg-white text-zinc-900 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider">
          {t("trial_ribbon_cta")} <ArrowRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </Link>
  );
}
